module.exports = __webpack_public_path__ + "img/dentinho-ajuda-teste-balaov3.3d8f9576.png";